import {
    Box,
    Grid,
    Typography,
    SxProps,
    Theme,
    List,
    Divider,
    Stack,
} from "@mui/material";
import PeopleCarousel from "../components/PeopleCarousel";
import { CommonStyles } from "../styles/CommonStyles";
import { AboutUsPerson } from "../types";
import { useIsMobile } from "../hooks";
import PageTitle from "../components/PageTitle";
import PageContent from "../components/PageContent";
import timelineEngMobileImg from "../assets/timeline_eng_m.svg";
import timelineEngImg from "../assets/timeline_eng.svg";
import timelineItaImg from "../assets/timeline_ita.svg";
import timelineItaMobileImg from "../assets/timeline_ita_m.svg";
import aboutUs1Img from "../assets/aboutus1.webp";
// import aboutUs1Img from "../assets/aboutus1.webp";
import aboutUs2Img from "../assets/aboutus22.webp";
import aboutUsPlayer1 from "../assets/key_giuseppecorcione.webp";
import aboutUsPlayer2 from "../assets/key_stefaniacarlucci.webp";
import aboutUsPlayer3 from "../assets/key_giovannigirasole.webp";
import aboutUsPlayer5 from "../assets/key_fabriziomarrone.webp";
import aboutUsPlayer6 from "../assets/key_vittoriorizzi.webp";
import PersonCardMobile from "../components/PeopleCardMobile";
import { useTranslation } from "react-i18next";
import i18n from "../i18n";

const AboutUsStyle: Record<string, SxProps<Theme>> = {
    captionTitle: {
        fontSize: "27px",
        textAlign: "left",
    },
    captionTitleMobile: {
        fontSize: "20px",
        textAlign: "center",
    },
    captionText: {
        fontSize: "17px",
        textAlign: "left",
    },
    captionTextMobile: {
        fontSize: "18px",
        textAlign: "center",
        // background: "#37314A",
        // padding: "20px",
        // borderRadius: "10px",
        marginTop: "20px",
    },
    mapContainer: {
        position: "relative",
    },
    mapTooltipPoint: {
        position: "absolute",
        svg: {
            width: "10px",
            cursor: "pointer",
            color: "#ffffff",
            "&:hover": { color: "secondary.main" },
        },
    },
    mapTooltipText: {
        fontSize: "1rem",
    },
    mapImageContainerMobile: {
        width: "100%",
        alignContent: "center",
        alignItems: "center",
        img: {
            maxWidth: "350px",
            width: "100%",
            height: "auto",
        },
    },
    mapTextMobile: {
        fontSize: "1.3rem",
    },
    uspTableHeader: {
        fontSize: "1.5rem",
        color:  "secondary.main",
    },
    uspTableHeaderMobile: {
        fontSize: "1.1rem",
        color:  "secondary.main",
    }
};

const players: AboutUsPerson[] = [
    {
        id: 1,
        name: "Giuseppe Corcione",
        position: "Chief Executive Officer & Founder",
        descriptionIt:
            "Sognatore, imprenditore, divulgatore della mobilità del futuro. Ama la musica e suona la batteria. Dopo esperienze nazionali e internazionali, mette a servizio la sua expertise fondando e gestendo alcune realtà innovative tra cui Reinova",
        descriptionEn:
            "Dreamer, entrepreneur, promoter of future mobility. He loves music and plays the drums. After gaining national and international experience, he put his expertise to good use by founding and managing a number of innovative companies, including Reinova.",
        image: aboutUsPlayer1,
    },
    {
        id: 2,
        name: "Stefania Carlucci",
        position: "Chief Customer Officer",
        descriptionIt:
            "Solare, attenta e sempre aperta alle nuove collaborazioni, Stefania gestisce il team di sales e sviluppa soluzioni strategiche per diffondere la voce e l'immagine di Reinova nei mercati internazionali.",
        descriptionEn: "Sunny, attentive and always open to new collaborations, Stefania manages the sales team and develops strategic solutions to spread Reinova's voice and image in international markets.",
        image: aboutUsPlayer2,
    },
    {
        id: 3,
        name: "Giovanni Girasole",
        position: "Chief Technology Officer",
        descriptionIt:
            "Da sempre nel settore Automotive, con un solido background nell'elettronica e nel software, Giovanni ha seguito tutte le fasi di sviluppo e testing di componenti elettrici ed elettronici installati su veicoli. Curioso e dinamico, ha scelto di affrontare la sfida dell'elettrificazione insieme a Reinova.",
        descriptionEn: "With a lifelong career in the Automotive sector and a solid background in electronics and software, Giovanni has overseen every phase of development and testing for electrical and electronic components installed on vehicles. Curious and dynamic, he chose to take on the challenge of electrification together with Reinova.",
        image: aboutUsPlayer3,
    },
    {
        id: 4,
        name: "Fabrizio Marrone",
        position: "Chief Testing & Validation Officer",
        descriptionIt:
            "Con oltre 20 anni di esperienza nella mobilità elettrica, Fabrizio, ingegnere elettrico, coordina test, validazioni, omologazioni, prototipi e riparazioni nei laboratori Reinova o presso i clienti, con l’obiettivo di ottimizzare i processi e offrire le migliori soluzioni.",
        descriptionEn: "With over 20 years of experience in electric mobility, Fabrizio, an electrical engineer, coordinates testing, validation, certification, prototyping, and repairs in Reinova's laboratories or at customer sites, with the aim of optimizing processes and offering the best solutions.",
        image: aboutUsPlayer5,
    },
    {
        id: 5,
        name: "Vittorio Rizzi",
        position: "Chief Management Officer",
        descriptionIt:
            "Dotato di abilità relazionali, doti analitiche, spirito collaborativo e creatività tecnica, Vittorio, ingegnere meccanico con lunga esperienza nell’automotive, supervisiona e coordina le funzioni operative di Reinova, migliorando processi, qualità e prestazioni della facility.",
        descriptionEn: "With analytical abilities, collaborative spirit, and technical creativity, Vittorio, a mechanical engineer with extensive experience in the automotive industry, supervises and coordinates Reinova's operational functions, improving processes, quality, and facility performance.",
        image: aboutUsPlayer6,
    },

];

const AboutUsPage = () => {
    const { isMobile } = useIsMobile(1200);
    const { t } = useTranslation();

    return (
        <>
            <PageTitle>{t("menu.about")}</PageTitle>
            <PageContent>
                <Grid container spacing={6} alignItems={"center"}>
                    {/* <Grid item md={12} lg={12} sx={{ margin: "90px 0px 0px 0px" }}>
               
                        <Typography
                            sx={
                                isMobile
                                    ? AboutUsStyle.captionTextMobile
                                    : AboutUsStyle.captionText
                            }
                        >
                            {t("aboutus.intro.1")}
                        </Typography>
                        <Typography
                            sx={[
                                isMobile
                                    ? AboutUsStyle.captionTextMobile
                                    : AboutUsStyle.captionText,
                            ].flat(2)}
                        >
                            {t("aboutus.intro.2")}
                        </Typography>
                    </Grid> */}

                    <Grid item lg={3} md={12} xs={12}>
                        <Box
                            sx={
                                isMobile
                                    ? CommonStyles.borderedImageMobile
                                    : CommonStyles.borderedImage
                            }
                        >
                            <img src={aboutUs1Img} alt="" width={"100%"}/>
                        </Box>
                    </Grid>

                    {/*  philosophy & mindset */}
                    <Grid item lg={9} md={12} xs={12}>
                        <Typography sx={isMobile ? CommonStyles.pageSectionTitleMobile : CommonStyles.pageSectionTitle}>
                            {t("aboutus.ourphilosophy")}
                        </Typography>
                        <Typography sx={isMobile ? AboutUsStyle.captionTextMobile : AboutUsStyle.captionText}>
                            {t("aboutus.philosophy")}
                        </Typography>
                        <List>
                            <Typography sx={isMobile ? AboutUsStyle.captionTextMobile : AboutUsStyle.captionText}>
                                {t("aboutus.philosophy.1")}
                            </Typography>
                            <Typography sx={isMobile ? AboutUsStyle.captionTextMobile : AboutUsStyle.captionText}>
                                {t("aboutus.philosophy.2")}
                            </Typography>
                            <Typography sx={isMobile ? AboutUsStyle.captionTextMobile : AboutUsStyle.captionText}>
                                {t("aboutus.philosophy.3")}
                            </Typography>
                        </List>
                        <Typography sx={isMobile ? CommonStyles.pageSectionTitleMobile : CommonStyles.pageSectionTitle}>
                            {t("aboutus.ourmindset")}
                        </Typography>
                        <Typography sx={isMobile ? AboutUsStyle.captionTextMobile : AboutUsStyle.captionText}>
                            {t("aboutus.mindset")}
                        </Typography>
                    </Grid>
                    {/*  /philosophy & mindset */}
                    
                    {/*  vision & problem */}
                    <Grid item lg={7} md={12} xs={12} order={isMobile ? 2 : 1}>
                        <Typography
                            sx={
                                isMobile
                                    ? CommonStyles.pageSectionTitleMobile
                                    : CommonStyles.pageSectionTitle
                            }
                        >
                            {t("aboutus.ourvision")}
                        </Typography>
                        <Typography
                            sx={
                                isMobile
                                    ? AboutUsStyle.captionTextMobile
                                    : AboutUsStyle.captionText
                            }
                        >
                            {t("aboutus.vision.1")}
                        </Typography>
                        <Typography
                            sx={
                                isMobile
                                    ? AboutUsStyle.captionTextMobile
                                    : AboutUsStyle.captionText
                            }
                        >
                            {t("aboutus.vision.2")}
                        </Typography>
                        <Typography
                            sx={
                                isMobile
                                    ? CommonStyles.pageSectionTitleMobile
                                    : CommonStyles.pageSectionTitle
                            }
                        >
                            {t("aboutus.ourproblem")}
                        </Typography>
                        <Typography
                            sx={
                                isMobile
                                    ? AboutUsStyle.captionTextMobile
                                    : AboutUsStyle.captionText
                            }
                        >
                            {t("aboutus.problem.1")}
                        </Typography>
                        <Typography
                            sx={
                                isMobile
                                    ? AboutUsStyle.captionTextMobile
                                    : AboutUsStyle.captionText
                            }
                        >
                            {t("aboutus.problem.2")}
                        </Typography>
                    </Grid>
                    
                    <Grid item lg={5} md={12} xs={12} order={isMobile ? 1 : 2}>
                        <Box
                            sx={
                                isMobile
                                    ? CommonStyles.borderedImageMobile
                                    : CommonStyles.borderedImage
                            }
                        >
                            <img src={aboutUs2Img} alt= "" width={"100%"}/>
                        </Box>
                    </Grid>
                </Grid>
                
                <Grid container sx={{ alignItems: "center", marginTop: "60px" }}>
                    <Grid item md={12} sm={12} xs={12}>
                        <Typography
                            sx={[
                                isMobile
                                    ? CommonStyles.pageSectionTitleMobile
                                    : CommonStyles.pageSectionTitle
                                , {textAlign: "center"}
                            ].flat(2)}
                        >
                            {t("aboutus.ourstory")}
                        </Typography>

                        <img src={i18n.resolvedLanguage === "en" ? (isMobile ? timelineEngMobileImg : timelineEngImg) : (isMobile ? timelineItaMobileImg : timelineItaImg)} width={isMobile ? "60%" : "100%"} alt=""/>
                    </Grid>
                </Grid>

                <Grid container sx={{ alignItems: "center", marginTop: "60px" }}>
                    <Grid item md={12} sm={12} xs={12} sx={{marginBottom: "50px"}}>
                        <Typography
                            sx={[
                                isMobile
                                    ? CommonStyles.pageSectionTitleMobile
                                    : CommonStyles.pageSectionTitle
                                , {textAlign: "center"}
                            ].flat(2)}
                        >
                            {t("aboutus.usp")}
                        </Typography>
                    </Grid>
                    <Stack spacing={4}>
                    {
                        Array.from({ length: 8 }, (_, i) => i + 1).map((num) => (<>
                            <Grid container spacing={2}>
                                <Grid item lg={4} md={12} xs={12} textAlign={"left"}>
                                    <Typography sx={isMobile ? AboutUsStyle.uspTableHeaderMobile : AboutUsStyle.uspTableHeader}>{t(`aboutus.usp.${num}.title`)}</Typography>
                                </Grid>
                                <Grid item lg={8} md={12} xs={12} textAlign={"left"}>
                                    <Typography>{t(`aboutus.usp.${num}.desc`)}</Typography>
                                </Grid>
                            </Grid>
                            <Grid item md={12}>
                                {
                                    num < 8 && <Divider sx={{borderBottomWidth: 4, borderColor: (theme: Theme) => theme.palette.primary.light }}/>
                                }
                            </Grid>
                        </>
                        ))
                    }
                    </Stack>
                </Grid>
                
                <Grid container sx={{ alignItems: "center", marginTop: "60px" }}>
                    <Grid item md={12} sm={12} xs={12} sx={{marginBottom: "50px"}}>
                        <Typography sx={[isMobile ? CommonStyles.pageSectionTitleMobile : CommonStyles.pageSectionTitle, {textAlign: "center"}].flat(2)}>
                            {t("aboutus.ourkeyplayer")}
                        </Typography>
                    </Grid>
                </Grid>

                {
                    isMobile ? 
                    <Grid
                        container
                        sx={{ alignItems: "center", marginTop: "30px" }}
                        spacing={1}
                    >
                        {players.map((_player) => (
                            <Grid item md={6} sm={6} xs={6}>
                                <PersonCardMobile person={_player} />
                            </Grid>
                        ))}
                    </Grid> 
                    :
                    <Grid container sx={{ alignItems: "center", marginTop: "30px" }}>
                        <Grid item md={12} sx={{}}>
                            <PeopleCarousel items={players} />
                        </Grid>
                    </Grid>
                }
            </PageContent>
        </>
    );
};

export default AboutUsPage;
